import "./App.css";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Inicio from "./pages/inicio/index.jsx";
import DetalleFactura from "./pages/detalle-factura/index.jsx";
import NotFound from "./pages/not-found/Index.jsx";
import NavBar from "./common/components/navbar/NavBar.jsx";
import RoleGuard from "./common/components/guards/RoleGuard.jsx";
import { useComprasAuth } from "./common/hooks/useComprasAuth.js";
import { useClarity } from "./common/hooks/useClarity.js";

function App() {
  const { authenticated, username, email, fullName } = useComprasAuth();

  useClarity({
    clarityId: import.meta.env.VITE_CLARITY_ID,
    authenticated,
    username,
    email,
    fullName,
  });

  return (
    <RoleGuard requiredRole="acceso-compras">
      <BrowserRouter>
        <NavBar />
        <div className="mt-[20px] lg:mx-[95px] mx-[40px] relative">
          <Routes>
            <Route path="/" element={<Inicio />} />
            <Route path="/detalle-factura/:idComprobante" element={<DetalleFactura />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </BrowserRouter>
    </RoleGuard>
  );
}

export default App;
